import React, { Component } from "react"
import { IntlProvider, addLocaleData, FormattedMessage } from "react-intl"
import en from "react-intl/locale-data/en"
import enMessages from "../../locales/en.js"
import Img from 'gatsby-image'
import it from "react-intl/locale-data/it"
import itMessages from "../../locales/it.js"
import Link from 'gatsby-link'

import Nav from '../Nav'

addLocaleData([...it, ...en])

const messages = {
  it: itMessages,
  en: enMessages
}

const locales = ["en", "it"]

class Header extends Component {

  componentDidMount() {
    window.onscroll = function() {stickyHeader()}

    let header = document.querySelector("#header")

    let sticky = header.offsetTop

    function stickyHeader() {
      if (window.pageYOffset > sticky) {
        header.classList.add("sticky")
      } else {
        header.classList.remove("sticky")
      }
    }
  }

  render() {

    const language = this.props.language
    const logo = this.props.logo
    const logoBlue = this.props.logoBlue

    let headerClass = this.props.length > 2 ? "header--page" : "header"

    return(
      <div className={`${headerClass}`} id="header">
        <div className="wrap">
          <div className="header__body">
            <div className="cartiglio">
              <div className="header__logo">
                <Link
                  to={`/${language}`}
                >
                  <Img
                    key={ logo.id }
                    sizes={ logo.sizes }
                  />
                </Link>
              </div>
              <div className="header__logo--blue">
                <Link
                  to={`${language}/`}
                >
                  <Img
                    key={ logoBlue.id }
                    sizes={ logoBlue.sizes }
                  />
                </Link>
              </div>
              <div className="header__name">
                <ul>
                  <li>Advantage</li>
                  <li
                    style={{
                      lineHeight: 0.7
                    }}
                  >Premiere Residence</li>
                </ul>
              </div>
            </div>
            <Nav language={ language } />
          </div>
        </div>
      </div>
    )
  }
}

export default Header



// WEBPACK FOOTER //
// ./src/components/Header/index.js